import { type JSX } from 'react';

import { type Repub } from '@cx-modules/types';

import { getStartTime } from '../../helpers';
import { useMatchesCouponContext } from '../../hooks';

import { StartTimeText } from './style';

interface StartTimeProps {
  repub: Repub;
  startTime: string;
}

export const StartTime = ({ repub, startTime }: StartTimeProps): JSX.Element => {
  const timeZone = useMatchesCouponContext(state => state.timeZone);

  const linkAttr = { rel: 'noopener' };

  return (
    <StartTimeText data-testid="start-time" {...linkAttr}>
      {getStartTime(startTime || '', repub, timeZone)}
    </StartTimeText>
  );
};
